export var Name = 'link-click';
export var LinkClick = Name;